import { Component, OnInit, Input } from '@angular/core';
import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { SupervisorModalComponent } from '../../modals/supervisor-modal/supervisor-modal.component';
import { QuestionDifficultyModalComponent } from '../../modals/questiondifficulty-modal/questiondifficulty-modal.component';
import { LevelModalComponent } from '../../modals/level-modal/level-modal.component';
import { SubjectModalComponent } from '../../modals/subject-modal/subject-modal.component';
import { ClasssetModalComponent } from '../../modals/classset-modal/classset-modal.component';
import { ExamTypeModalComponent } from '../../modals/examtype-modal/examtype-modal.component';
import { DeleteConfirmDialogComponent } from '../../shared/delete-confirm-dialog/delete-confirm-dialog.component';
import { SupervisorService } from '../../providers/supervisor/supervisor.service';
import { LevelService } from '../../providers/level/level.service';
import { ClassSetService } from '../../providers/class-set/class-set.service';
import { ExamtypeService } from '../../providers/examtype/examtype.service';
import { QuestiondifficultyService } from '../../providers/questiondifficulty/questiondifficulty.service';
import { SubjectService } from '../../providers/subject/subject.service';
import { DifficultyModifierModalComponent } from '../../modals/difficulty-modifier-modal/difficulty-modifier-modal.component';
import { DifficultymodifiersService } from '../../providers/difficultymodifiers/difficultymodifiers.service';

export interface LevelData {
  id: number;
}

@Component({
  selector: 'app-app-settings',
  templateUrl: './app-settings.component.html',
  styleUrls: ['./app-settings.component.scss']
})
export class AppSettingsComponent implements OnInit {
  supervisorData;
  levelData;
  examTypeData;
  classSetData;
  questionDifData;
  subjectData;
  modifierData;
  @Input() message: string;

  constructor(public dialog: MatDialog,
    private supervisorService: SupervisorService,
    private levelService: LevelService,
    private examTypeService: ExamtypeService,
    private classSetService: ClassSetService,
    private questionDifficultyService: QuestiondifficultyService,
    private subjectService: SubjectService,
    public modifierService: DifficultymodifiersService
  ) { 
    this.getsupervisorData();
    this.getlevelData();
    this.getexamTypeData();
    this.getclassSetData();
    this.getquestDiffData();
    this.getsubjectData();
    this.getmodifierData();
  }

  // supervisor modal
  openDialogSupervisor(): void {
    const dialogRef = this.dialog.open(SupervisorModalComponent, {
      width: '350px',
      data: {
        title: 'Create new supervisor'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getsupervisorData();
    });
  }

  // level modal
  openDialogLevel(): void {
    const dialogRef = this.dialog.open(LevelModalComponent, {
      width: '350px',
      data: {
        title: 'Create new level'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      // this.email = result;
      this.getlevelData();
    });
  }

  // subject modal
  openDialogSubject(): void {
    const dialogRef = this.dialog.open(SubjectModalComponent, {
      width: '350px',
      data: {
        title: 'Create new subject'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getsubjectData();
    });
  }

  // class set modal
  openDialogClassSet(): void {
    const dialogRef = this.dialog.open(ClasssetModalComponent, {
      width: '350px',
      data: {
        title: 'Create new class set'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getclassSetData();
    });
  }

  // exam type modal 
  openDialogExamType(): void {
    const dialogRef = this.dialog.open(ExamTypeModalComponent, {
      width: '350px',
      data: {
        title: 'Create new exam type'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getexamTypeData();
    });
  }

  // question modal 
  openDialogQuestion(): void {
    const dialogRef = this.dialog.open(QuestionDifficultyModalComponent, {
      width: '350px',
      data: {
        title: 'Create new question difficulty'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getquestDiffData();
    });
  }

  //modifier Modal
  openDialogModifier(): void {
    const dialogRef = this.dialog.open(DifficultyModifierModalComponent, {
      width: '350px',
      data: {
        title: 'Create new Diffculty Modiefier'
      }
    })

    dialogRef.afterClosed().subscribe(result => {
      //get data here
    })
  }

  ngOnInit(): void {
    this.getsupervisorData();
    this.getlevelData();
    this.getexamTypeData();
    this.getclassSetData();
    this.getquestDiffData();
    this.getsubjectData();
  }

  //returns supervisor data
  getsupervisorData() {
    this.supervisorService.viewSupervisor()
      .pipe(map(
        data => { console.log(data); return data }
      )).subscribe(
        data => {
          this.supervisorData = data;
        });
  }

  //returns level data
  getlevelData() {
    this.levelService.viewLevel()
      .pipe(map(
        data => { return data }
      )).subscribe(
        data => {
          this.levelData = data;
        });
  }

  //returns exam type data
  getexamTypeData() {
    this.examTypeService.viewExamType()
      .pipe(map(
        data => { return data }
      )).subscribe(
        data => {
          this.examTypeData = data;
        });
  }

  //returns class set data
  getclassSetData() {
    this.classSetService.viewClassSet()
      .pipe(map(
        data => { return data }
      )).subscribe(
        data => {
          this.classSetData = data;
        });
  }

  //returns question difficulty data
  getquestDiffData() {
    this.questionDifficultyService.viewQuestionDifficulty()
      .pipe(map(
        data => { return data }
      )).subscribe(
        data => {
          this.questionDifData = data;
        });
  }

  //returns subject data
  getsubjectData() {
    this.subjectService.viewSubject()
      .pipe(map(
        data => { return data }
      )).subscribe(
        data => {
          this.subjectData = data;
        });
  }

  //return modifier data
  getmodifierData() {
    this.modifierService.viewModifier()
      .pipe(map(
        data => { return data }
      )).subscribe(
        data => {
          this.modifierData = data;
          console.log(this.modifierData);
        });
  }

  // editing supervisor
  editSupervisor(supervisorObj) {
    const dialogRef = this.dialog.open(SupervisorModalComponent, {
      width: '350px',
      data: {
        id: supervisorObj.sysRef,
        firstname: supervisorObj.firstName,
        lastname: supervisorObj.lastName,
        teacherid: supervisorObj.teacherId,
        phone: supervisorObj.phone,
        email: supervisorObj.email,
        title: 'Edit supervisor ' + supervisorObj.firstName
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      this.getsupervisorData();
    });

  }

  // editing level
  editLevel(levelObj) {
    const dialogRef = this.dialog.open(LevelModalComponent, {
      width: '350px',
      data: {
        id: levelObj.sysRef,
        description: levelObj.description,
        heirarchy: levelObj.heirarchy,
        title: 'Edit level ' + levelObj.description
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      this.getlevelData();
    });

  }

  // editing subject
  editSubject(subjectObj) {
    const dialogRef = this.dialog.open(SubjectModalComponent, {
      width: '350px',
      data: {
        id: subjectObj.sysRef,
        name: subjectObj.name,
        description: subjectObj.description,
        title: 'Edit subject ' + subjectObj.name
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      this.getsubjectData();
    });

  }

  // editing class set
  editClassSet(classsetObj) {
    const dialogRef = this.dialog.open(ClasssetModalComponent, {
      width: '350px',
      data: {
        id: classsetObj.sysRef,
        name: classsetObj.name,
        description: classsetObj.description,
        title: 'Edit class set ' + classsetObj.name
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      this.getclassSetData();
    });

  }

  // editing exam type
  editExamType(examTypeObj) {
    const dialogRef = this.dialog.open(ExamTypeModalComponent, {
      width: '350px',
      data: {
        id: examTypeObj.sysRef,
        name: examTypeObj.name,
        description: examTypeObj.description,
        title: 'Edit exam type ' + examTypeObj.name
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getexamTypeData();
    });

  }

  // editing question difficulty
  editQuestionDifficulty(questDiffObj) {
    const dialogRef = this.dialog.open(QuestionDifficultyModalComponent, {
      width: '350px',
      data: {
        id: questDiffObj.sysRef,
        name: questDiffObj.name,
        description: questDiffObj.description,
        title: 'Edit question difficulty ' + questDiffObj.name
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getquestDiffData();
    });

  }

  // editing Modifiers
  editQuestionModifiers(mod) {
    const dialogRef = this.dialog.open(DifficultyModifierModalComponent, {
      width: '350px',
      data: {
        id: mod.sysRef,
        Level: mod.level,
        QuestionDifficulty: mod.questionDifficulty,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getmodifierData();
    });

  }

  // deleting a supervisor
  deleteSupervisor(supervisorObj): void {
    const dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
      width: '350px',
      data: {
        component: 'supervisor',
        id: supervisorObj.sysRef,
        title: 'Confirm Delete',
        message: 'Are you sure, you want to remove supervisor: ' + supervisorObj.firstName
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getsupervisorData();
    });
  }

  // deleting a level
  deleteLevel(levelObj): void {
    const dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
      width: '350px',
      data: {
        component: 'level',
        id: levelObj.sysRef,
        title: 'Confirm Delete',
        message: 'Are you sure, you want to remove level: ' + levelObj.description
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getlevelData();
    });
  }

  // deleting a subject
  deleteSubject(subjectObj): void {
    const dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
      width: '350px',
      data: {
        component: 'subject',
        id: subjectObj.sysRef,
        title: 'Confirm Delete',
        message: 'Are you sure, you want to remove subject: ' + subjectObj.name
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getsubjectData();
    });
  }

  // deleting a class set
  deleteClassSet(classsetObj): void {
    const dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
      width: '350px',
      data: {
        component: 'classset',
        id: classsetObj.sysRef,
        title: 'Confirm Delete',
        message: 'Are you sure, you want to remove class set: ' + classsetObj.name
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getclassSetData();
    });

  }

  // deleting an exam type
  deleteExamType(examTypeObj): void {
    const dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
      width: '350px',
      data: {
        component: 'examtype',
        id: examTypeObj.sysRef,
        title: 'Confirm Delete',
        message: 'Are you sure, you want to remove Exam Type: ' + examTypeObj.name
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getexamTypeData();
    });
  }

  // deleting a question difficulty
  deleteQuestionDifficulty(quedifObj): void {
    const dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
      width: '350px',
      data: {
        component: 'questiondifficulty',
        id: quedifObj.sysRef,
        title: 'Confirm Delete',
        message: 'Are you sure, you want to remove question difficulty ' + quedifObj.name
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getquestDiffData();
    });
  }

  // deleting a moifieri diffculty
  deleteModifier(mod): void {
    const dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
      width: '350px',
      data: {
        component: 'modifiers',
        id: mod.sysRef,
        title: 'Confirm Delete',
        message: 'Are you sure, you want to remove this modifier?'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.modifierData();
    });
  }
}

